import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import FeedPage from "@/pages/FeedPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ProfilePage from "@/pages/ProfilePage";
import DiscoverPage from "@/pages/DiscoverPage";
import CreatePostPage from "@/pages/CreatePostPage";
import NotificationsPage from "@/pages/NotificationsPage";
import MessagesPage from "@/pages/MessagesPage";
import TeamPage from "@/pages/TeamPage";
import ComparePage from "@/pages/ComparePage";
import GuardianPage from "@/pages/GuardianPage";
import ConfirmGuardianPage from "@/pages/ConfirmGuardianPage";
import AdminPage from "@/pages/AdminPage";
import PublicPostPage from "@/pages/PublicPostPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import WelcomePage from "@/pages/WelcomePage";
import ShortlistsPage from "@/pages/ShortlistsPage";
import { Toaster } from "sonner";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="p-8 text-[#737373]">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AppShell({ children }) {
  return (
    <div className="App egncy-noise min-h-screen">
      <Navbar />
      <main className="relative z-10">{children}</main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route
            path="/p/:postId"
            element={<AppShell><PublicPostPage /></AppShell>}
          />
          <Route path="/confirm-guardian" element={<ConfirmGuardianPage />} />
          <Route
            path="/admin"
            element={<AppShell><AdminPage /></AppShell>}
          />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppShell><FeedPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/welcome"
            element={
              <ProtectedRoute>
                <WelcomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/shortlists"
            element={
              <ProtectedRoute>
                <AppShell><ShortlistsPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/discover"
            element={
              <ProtectedRoute>
                <AppShell><DiscoverPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/create"
            element={
              <ProtectedRoute>
                <AppShell><CreatePostPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/:userId"
            element={
              <ProtectedRoute>
                <AppShell><ProfilePage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <AppShell><NotificationsPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <AppShell><MessagesPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/messages/:conversationId"
            element={
              <ProtectedRoute>
                <AppShell><MessagesPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/team/:teamName"
            element={
              <ProtectedRoute>
                <AppShell><TeamPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/compare"
            element={
              <ProtectedRoute>
                <AppShell><ComparePage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route
            path="/family"
            element={
              <ProtectedRoute>
                <AppShell><GuardianPage /></AppShell>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster theme="dark" />
      </BrowserRouter>
    </AuthProvider>
  );
}
